import { RequestStatus } from "@fitness-app/data-models";

import { closeRealtimeChannel } from "../../../helpers/closeRealtimeChannel";
import { type AppThunk } from "../../../index";
import { unsubscribeFromChannel as actionCreator, setCurrentChannelStatus } from "../reducer";

export const unsubscribeFromChannelMessages =
  (channelId: string): AppThunk =>
  async (dispatch, getState, { subscriptions, db, parties }) => {
    const channelSubscription = subscriptions.channels[channelId];

    if (channelSubscription) {
      // detach synchronously - awaiting the close first would let a subscribe that
      // already claimed the slot store its channel, only for this thunk to null it out
      const channel = channelSubscription.realtimeChannel;
      channelSubscription.realtimeChannel = null;
      channelSubscription.realtimeChannelName = null;
      void closeRealtimeChannel(db, channel);
    }

    if (parties.chatRooms[channelId]) {
      parties.chatRooms[channelId]?.close();
      parties.chatRooms[channelId] = null;
    }

    if (parties.chatRoomsNative[channelId]) {
      parties.chatRoomsNative[channelId]?.close();
      parties.chatRoomsNative[channelId] = null;
    }

    dispatch(setCurrentChannelStatus(RequestStatus.IDLE));
    dispatch(actionCreator(channelId));
  };
